import { PplxError } from '#pplx/frontend/common/errors.js';
/**
 * Format this log a bit so DD agent can ingest
 * @param message message to log
 * @returns serialized message
 */
export function formatLog(...messages) {
    let messageContainError;
    const extra = {};
    const messagesContainString = [];
    messages.filter(Boolean).forEach((m) => {
        if (m instanceof PplxError) {
            messageContainError = m;
            messagesContainString.push(m.message);
            if (m.details) {
                Object.assign(extra, {
                    pplx_error_code: m.code,
                    ...m.details,
                });
            }
        }
        else if (m instanceof Error) {
            messageContainError = m;
            messagesContainString.push(m.message);
        }
        else if (typeof m === 'object') {
            Object.assign(extra, m);
        }
        else {
            messagesContainString.push(m);
        }
    });
    const message = messagesContainString.join(' ');
    // Deal with Error object
    if (messageContainError) {
        return {
            message,
            error: messageContainError,
            extra,
        };
    }
    return {
        message,
        extra,
    };
}
//# sourceMappingURL=core.js.map